import { API_URL, Status } from '../constants';
import { fetch } from '../fetchWrapper/fetch';

export const deleteVenueAddress = async (venueId: string, addressId: string): Promise<void> => {
  const url = `${API_URL}/venues/${venueId}/address/${addressId}`;

  try {
    const res = await fetch(url, {
      method: 'DELETE',
    });
    if (res.status !== Status.NO_CONTENT) {
      const json = await res.json();
      throw new Error(json.message);
    }
  } catch (e) {
    throw new Error(e);
  }
};
